import { ChevronDownIcon } from '@heroicons/react/24/outline'
import { ReactNode } from 'react'

/**
 * Props for the MobileMenuSection component
 */
interface MobileMenuSectionProps {
  /** Section title */
  title: string
  /** Section content */
  children: ReactNode
  /** Additional CSS classes */
  className?: string
}

/**
 * Mobile menu accordion section component
 * Provides collapsible sections for organizing navigation items
 */
export const MobileMenuSection = ({ 
  title, 
  children, 
  className = '' 
}: MobileMenuSectionProps) => {
  return (
    <details className={`border-b border-gray-200 pb-2 mb-2 group ${className}`.trim()}>
      <summary 
        className="flex items-center justify-between p-3 text-lg font-semibold text-gray-800 cursor-pointer rounded-lg transition-colors duration-200 hover:bg-gray-50 list-none focus:outline-none focus:ring-2 focus:ring-vi-red focus:ring-offset-2"
      >
        <span>{title}</span>
        <ChevronDownIcon 
          className="w-5 h-5 transition-transform duration-200 flex-shrink-0 group-open:rotate-180" 
          aria-hidden="true"
        />
      </summary>

      <div className="p-4 animate-in slide-in-from-top-2 duration-200">
        <div className="flex flex-col gap-3" role="menu">
          {children}
        </div>
      </div>
    </details>
  )
}
